// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointment-config-modal__talk-room-description[data-v-31e9db82]{color:var(--color-text-maxcontrast)}`, "",{"version":3,"sources":["webpack://./src/components/AppointmentConfigModal.vue"],"names":[],"mappings":"AAEE,kEACC,mCAAA","sourcesContent":[".appointment-config-modal__talk-room-description{color:var(--color-text-maxcontrast)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
